import type { AxiosRequestConfig } from 'axios'
import axios from 'axios'

import type {
  ContactSubmissionInput,
  ContactSubmissionResponse,
} from '@beaded/models'

import { API_HOSTNAME } from 'constants/api'

import { POST } from '.'

/**
 * Contact-submission endpoints.
 *
 * - Public submit goes through /api/v1/public/contact (uses apiUtils.POST).
 * - Admin endpoints live under /api/admin/ (no version prefix), so we use
 *   API_HOSTNAME() directly.
 */
const config: AxiosRequestConfig = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
  },
  withCredentials: true,
}

const baseUrl = () => `${API_HOSTNAME()}/api`

/** POST /api/v1/public/contact (public, no auth) */
export const submit = (data: ContactSubmissionInput) =>
  POST('/public/contact', data)

/** GET /api/admin/contact-submissions (admin) */
export const getAll = (
  params?: {
    page?: number
    limit?: number
    unreadOnly?: boolean
  },
  options: AxiosRequestConfig = {},
): Promise<{ submissions: ContactSubmissionResponse[]; total: number }> =>
  axios
    .get(`${baseUrl()}/admin/contact-submissions`, {
      ...config,
      ...options,
      params,
    })
    .then((res) => res.data)

/** PATCH /api/admin/contact-submissions/:id (admin) */
export const markRead = (
  id: string,
  read: boolean,
): Promise<ContactSubmissionResponse> =>
  axios
    .patch(`${baseUrl()}/admin/contact-submissions/${id}`, { id, read }, config)
    .then((res) => res.data)
